// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ComingSoon {
  display: flex;
  position: relative;
  flex: 1 1;
  pointer-events: none;
  z-index: 1101;
  cursor: pointer;
  font-family: 'Roboto';
  line-height: 40px;
  overflow: hidden;
  padding: 8px;
}

.ComingSoon-label {
  display: flex;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  font-size: 28px;
  text-align: center;
  font-weight: bold;
  color: #d8d8d8;
  background: rgba(0, 0, 0, 0.5);
  z-index: 11;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/ComingSoon.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAO;EACP,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,8BAA8B;EAC9B,WAAW;EACX,oBAAoB;AACtB","sourcesContent":[".ComingSoon {\n  display: flex;\n  position: relative;\n  flex: 1;\n  pointer-events: none;\n  z-index: 1101;\n  cursor: pointer;\n  font-family: 'Roboto';\n  line-height: 40px;\n  overflow: hidden;\n  padding: 8px;\n}\n\n.ComingSoon-label {\n  display: flex;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  justify-content: center;\n  align-items: center;\n  font-size: 28px;\n  text-align: center;\n  font-weight: bold;\n  color: #d8d8d8;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 11;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
